import { atom } from 'recoil';

const stats = atom<AudioStats[]>({ key: 'audio-stats-list', default: [] });
const loading = atom<boolean>({ key: 'audio-stats-loading', default: false });

export const AudioStatsAtoms = {
  stats,
  loading,
};
